import { Region } from '@moonpig/web-core-types'
import React from 'react'
import isAbsoluteUrl from 'is-absolute-url'

const RESTRICTED_FREE_TEXT_CHARS = /[<>();\\:"={}^%$£#!*@.]/g
const RESTRICTED_EMAIL_CHARS = /[<>();\\:"={}^%$£#!*]/g
const INVALID_CHAR_REG_EXP = /[\r\n]+|%0a/

export const validateReturnUrl = (returnUrl: string) => {
  if (isAbsoluteUrl(returnUrl)) return undefined
  const sanitizedUrl = returnUrl.replace(INVALID_CHAR_REG_EXP, '')
  if (/(javascript|file|data):/.test(sanitizedUrl)) return undefined
  if (/^\/\/.*/.test(sanitizedUrl)) return undefined
  return sanitizedUrl
}

export const ensureReturnUrl = (
  returnUrl: string | undefined,
  region: Region,
): string => {
  if (!returnUrl) {
    return `/${region}/`
  }

  const validReturnUrl = validateReturnUrl(returnUrl)
  return validReturnUrl || `/${region}/`
}

export const redirect = (
  region: Region,
  returnUrl: string | undefined,
): void => {
  try {
    const url = ensureReturnUrl(returnUrl, region)
    window.history.pushState({}, '', url)
    window.location.assign(url)
  } catch {
    window.location.assign(`/${region}/`)
  }
}

export const restrictInput = (
  onChange: (...event: React.ChangeEvent<HTMLInputElement>[]) => void,
  fieldName: string,
) => {
  return (...event: React.ChangeEvent<HTMLInputElement>[]) => {
    const sanitizedEvents = event.map(e => {
      const { target } = e
      if (target && target.value) {
        const sanitizedValue = target.value.replace(
          fieldName === 'email'
            ? RESTRICTED_EMAIL_CHARS
            : RESTRICTED_FREE_TEXT_CHARS,
          '',
        )
        return { ...e, target: { ...target, value: sanitizedValue } }
      }
      /* istanbul ignore next */
      return e
    })

    onChange(...sanitizedEvents)
  }
}
